import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { DataWidgetModel } from '../models/widget-related/DataWidgetModel';
import { DataWidgetContainerService } from './data-widget-container.service';
import { NotificationHandlerService } from '../notifications/notification-handler.service';

@Component({
    selector: 'data-widget-container',
    templateUrl: 'data-widget-container.component.html'
})

export class DataWidgetContainerComponent implements OnInit {

    public allWidgets: string[];

    constructor(private _widgetService: DataWidgetContainerService, private _notificationService: NotificationHandlerService, public oidcSecurityService: OidcSecurityService) {

    }

    ngOnInit(): void {
        this.getData();
    }

    public getData() {
        this._widgetService
            .GetAll()
            .subscribe(data => {
                this.allWidgets = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                    this._notificationService.handleError(error)
            },
            () => {});
    }

}



// WEBPACK FOOTER //
// ./angularApp/app/shared/data-widget-container/data-widget-container.component.ts